import { CASHBACK_ACTION } from '../../../constants/actions'
import {
  extractInputValueAndError,
  isArray,
  mergeToNewObject
} from '../../../util/object.helpers'

export const cashbackProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CASHBACK_ACTION.ON_GET_CASHBACK_BRANDS:
    case CASHBACK_ACTION.ON_GET_CASHBACK_BRANDS_BY_SEARCH:
      const { loading, loadingBrand, page } = payload
      return mergeToNewObject(state, {
        loading: loading,
        loadingBrand: loadingBrand,
        page
      })

    case CASHBACK_ACTION.ON_GET_CASHBACK_BRANDS_SUCCESS:
    case CASHBACK_ACTION.ON_GET_CASHBACK_BRANDS_BY_SEARCH_SUCCESS:
      if (isArray(payload)) {
        return mergeToNewObject(state, {
          cashbackBrands: payload,
          loading: false,
          loadingBrand: false
        })
      }
      const { content, totalPages, last } = payload
      const cashbackBrands =
        state.page > 0 ? [...state.cashbackBrands, ...content] : content
      return mergeToNewObject(state, {
        cashbackBrands,
        loading: false,
        loadingBrand: false,
        totalPages,
        isLast: last || false
      })

    case CASHBACK_ACTION.ON_GET_CASHBACK_BRANDS_FAILED:
    case CASHBACK_ACTION.ON_GET_CASHBACK_BRANDS_BY_SEARCH_FAILED:
      return mergeToNewObject(state, {
        loading: false,
        loadingBrand: false
      })

    case CASHBACK_ACTION.ON_GET_CASHBACK_FILTER_CATEGORIES_SUCCESS:
      return mergeToNewObject(state, {
        filterCategories: payload
      })

    case CASHBACK_ACTION.ON_GET_CASHBACK_BRAND_DETAILS:
      return mergeToNewObject(state, {
        loadingDetails: true
      })

    case CASHBACK_ACTION.ON_GET_CASHBACK_BRAND_DETAILS_SUCCESS:
      return mergeToNewObject(state, {
        selectedCashbackBrand: payload,
        loadingDetails: false
      })

    case CASHBACK_ACTION.CHANGE_STATE:
      return mergeToNewObject(state, { [payload.property]: payload.value })

    case CASHBACK_ACTION.CHANGE_INPUT_STATE:
      return mergeToNewObject(
        state,
        extractInputValueAndError(payload, state.error)
      )

    case CASHBACK_ACTION.ON_SELECTED_CATEGORY:
      return mergeToNewObject(state, {
        ...(Object.keys(payload).length && {
          checkedCategoriesForFilter: payload
        })
      })

    case CASHBACK_ACTION.RESET_STATE:
      return { ...INITIAL_STATE, checkedCategoriesForFilter: {} }

    default:
      return state
  }
}

const INITIAL_STATE = {
  cashbackBrands: [],
  filterCategories: [],
  checkedCategoriesForFilter: {},
  loading: false,
  loadingBrand: false,
  loadingDetails: false,
  page: 0,
  totalPages: 0,
  isLast: false,
  error: {}
}

export const CASHBACK_PROFILE_DISPATCH = {
  LOADING_BRAND: 'loadingBrand',
  CHECKED_CATEGORIES_FOR_FILTER: 'checkedCategoriesForFilter'
}
